import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, Params, Actions, Merge } from 'nallian-table-builder-ui';
import { PageContent, PageTitle } from 'nallian-shared-ui/lib/components';
import { TABS, INFINITE_SCROLL, APPS_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';
import TypeToConfirmModal from '../../app/components/TypeToConfirmModal';
import RemoveAppService from '../services/removeAppService';

const AppsOverview = ({ dispatchRemoveAppDelete, removeAppFetch }) => {
  const { t } = useTranslation();

  const [removalItem, setRemovalItem] = useState(null);

  const handleCancel = useCallback(() => setRemovalItem(null), [setRemovalItem]);
  const handleSetRemovalItem = useCallback((_, item) => setRemovalItem(item), [setRemovalItem]);

  const handleRemove = useCallback(() => {
    dispatchRemoveAppDelete(removalItem.id, () => setRemovalItem(null), t);
  }, [removalItem, dispatchRemoveAppDelete, t]);

  return (
    <>
      <PageTitle>{t('apps_plural')}</PageTitle>
      <PageContent>
        <Table
          infiniteScroll={INFINITE_SCROLL}
          resource={APPS_RESOURCE}
          url={apiRoutes.apps()}
          pageSize={50}
          idProp="tag"
          noUserSettings
          filtered
          sorted
        >
          <Params.String
            link={`/apps/:id/${TABS.DETAILS}`}
            name="name"
            width="16rem"
            minWidth="16rem"
            grow
            noFilter
          />
          <Params.String name="tag" width="16rem" minWidth="16rem" grow noFilter />
          <Merge width="4.5rem" align="center" type="Menu" hasRight="apps/delete">
            <Actions.Button
              iconbutton
              icon="trash"
              label={t('removeApp')}
              content={t('removeApp')}
              onClick={handleSetRemovalItem}
            />
          </Merge>
        </Table>
        {removalItem && (
          <TypeToConfirmModal
            onConfirm={handleRemove}
            onCancel={handleCancel}
            header={t('app:areYouSureRemoveApp', { item: removalItem })}
            loading={removeAppFetch.pending}
            value={removalItem.name}
          />
        )}
      </PageContent>
    </>
  );
};

AppsOverview.propTypes = {
  dispatchRemoveAppDelete: PropTypes.func.isRequired,
  removeAppFetch: PropTypes.object.isRequired,
};

export default RemoveAppService(AppsOverview);
